import * as R from 'ramda';

export const getTimeFromDate = date => R.slice(11, 16, date);
